module.exports = __webpack_public_path__ + "img/323825136_899599537707825_1054301618380026162_n.f063ef48.jpeg";